module.exports = __webpack_public_path__ + "static/media/plus.2b25691a.png";